import * as React from 'react';
import { Button } from '@ooh/ui/components/button';

export interface TransportLineInfoPopupProps {
  label: string;
  typeLabel: string;
  x: number;
  y: number;
  onClose: () => void;
  closeAriaLabel: string;
}

export function TransportLineInfoPopup({
  label,
  typeLabel,
  x,
  y,
  onClose,
  closeAriaLabel,
}: TransportLineInfoPopupProps) {
  return (
    <div
      className="absolute z-40 rounded-lg border border-border/70 bg-background/97 px-3 py-2 shadow-md backdrop-blur-sm"
      style={{ left: x + 10, top: y - 48, pointerEvents: 'none' }}
      data-testid="line-info-popup"
    >
      <div className="flex items-start gap-2">
        <div>
          <p className="text-[13px] font-semibold text-foreground leading-tight">{label}</p>
          <p className="text-2xs text-muted-foreground mt-0.5">{typeLabel}</p>
        </div>
        <Button
          variant="ghost"
          size="icon-sm"
          onClick={onClose}
          aria-label={closeAriaLabel}
          style={{ pointerEvents: 'auto' }}
          className="ml-1 mt-0.5 h-5 w-5 text-muted-foreground hover:text-foreground"
        >
          ×
        </Button>
      </div>
    </div>
  );
}
